export default __webpack_public_path__ + "static/bannerPubli-DO-3a625031757c34f3f9ed07c99c1999f6.png";